export default __webpack_public_path__ + "static/media/gamepad.183ae77f.svg";